import { styled } from '@mui/material/styles'
import { StyledButton } from './StyledButton'

export const CompactButton = styled(StyledButton, {
    shouldForwardProp: (prop) => prop !== 'dense' && prop !== 'invert',
})(({ dense }) => ({
    ...(dense
        ? { width: 32, height: 32, minWidth: 32 }
        : {
              width: 40,
              height: 40,
              minWidth: 40,
          }),
    padding: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& .MuiButton-startIcon': {
        margin: 0,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        '& svg': {
            fontSize: '16px',
        },
    },
}))
